import { render } from "./CreateMenuItem.vue?vue&type=template&id=63de1066"
import script from "./CreateMenuItem.vue?vue&type=script&lang=js"
export * from "./CreateMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__